<template>
  <div>
    <dadosTitular v-if="step === 'dadosTitular'" :payload="payload"></dadosTitular>
    
    <endereco v-if="step == 'dadosEndereco'" :payload="payload"></endereco>
    
    <dependente v-if="step == 'dadosDependentes'" :payload="payload"></dependente>

    <pagamento v-if="step== 'dadosPagamento'" :payload="payload"></pagamento>

    
  </div>
</template>
<script>
import moment from 'moment';
import ufs from '@/utils/ufs';

import dadosTitular from '@/views/pedido/formulario/DadosTitular';
import endereco from '@/views/pedido/formulario/Endereco';
import dependente from '@/views/pedido/formulario/Dependentes';
import pagamento from '@/views/pedido/formulario/Pagamento';

export default {
  components: {
    dadosTitular,
    endereco,
    dependente,
    pagamento
  },
  computed: {
    empresa() {
      return this.$store.getters.empresa;
    },
    user() {
      return this.$store.getters.user;
    },
    valorTotalCartaoFisico() {
      return this.valorCartaoFisico * (this.dependentesCartaoFisico.length + 1);
    },
    step() {
      return this.$store.getters.step;
    },
    ufs() {
      return ufs;
    }
  },
  data() {
    return {
      payload: {
        uf: null,
        plano: null,
        email: null,
        dataNascimento: null,
        telefoneCelular: null,
        username: null,
        password: null,
        estado: null,
        naturalidade: null,
        sexo: null,
        cidade: null,
        ufEndereco: null,
        endereco: null,
        bairro: null,
        complemento: null,
        nrEndereco: null,
        cep: null,
        cpf: null,
        dependentes: []
      }
    };
  },
  methods: {
    getDataFormatada (date) {
      if (!date) {
        return ''
      }
      return moment(date).format('DD/MM/YYYY')
    },
    next(from, to) {
      this.$validator.validateAll(from).then(result => {
        if (result) {
          this.$store.disptach('setStep', to);
        }
      });
    },
    addDependente() {
      if (this.payload.dependentes.length < this.payload.plano.qtdDependentes) {
        this.payload.dependentes.push({});
      }
    },

    
  }
};
</script>